import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AIPlanPageState {
  editMode: boolean
}

const initialState: AIPlanPageState = {
  editMode: false
}

const aiPlanSlice = createSlice({
  name: 'aiPlan',
  initialState,
  reducers: {
    setEditMode: (state, action: PayloadAction<boolean>) => {
      state.editMode = action.payload
    },
    resetEditMode: state => {
      state.editMode = false
    }
  }
})

export const { setEditMode, resetEditMode } = aiPlanSlice.actions

export const selectAIPlanEditMode = (state: { aiPlan: AIPlanPageState }): boolean => {
  return state.aiPlan.editMode
}

export default aiPlanSlice.reducer
